import styles from './index.module.scss';
import Box from "@/app/_components/Shared/Box";

export default function Services({
     data,
    className = null,
    itemClassName = null,
   }) {
    return (
        <div className={`${styles.services} ${className}`}>
            {data.map((service, index) => (
                <Box
                    key={index}
                    className={itemClassName}
                    icon={service.icon}
                    title={service.title}
                    description={service.description}
                    buttonLink={service.button_link}
                    buttonText={service.button_text}
                />
            ))}
        </div>
    );
}